import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1230ec0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { id: "image-upload" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "orienteme-button-upload-title" }, "Clique ou arraste aqui", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "orienteme-button-upload-subtitle" }, " Selecione 1 arquivo 5mb ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["orienteme-upload-base", { 'orienteme-upload-base-full' : _ctx.hasFile }])
  }, [
    _createVNode(_component_el_upload, {
      class: "upload-button",
      drag: "",
      action: "",
      "on-change": _ctx.handleChange,
      "on-remove": _ctx.handleRemove,
      limit: _ctx.limit,
      "file-list": _ctx.model,
      "auto-upload": false
    }, {
      tip: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_row, { justify: "start" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 16 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { justify: "start" }, {
                  default: _withCtx(() => [
                    _hoisted_2,
                    _hoisted_3
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["on-change", "on-remove", "limit", "file-list"])
  ], 2))
}